// config
const $window = $(window);
const breakPoint = 767;
let resizeFlg = false;
let windowWidth = $window.width();

$(window).load(function () {
//	$("#ticket section .detail").tile(2);
	// loading();
	animation();
});
function animation() {
	$('h1').delay(100).animate({
		opacity: '1'
	},1000);
	setTimeout(function(){
		$('#idx-main .catchcopy').css({
			opacity: '1',
			transform: 'translate(0,0)'
		})
	},1500);
}

// $(function(){
//   var topBtn = $('.to-top');
//   topBtn.hide();
//   $(window).scroll(function () {
//     if ($(this).scrollTop() > 100) {
//       topBtn.fadeIn();
//     } else {
//       topBtn.fadeOut();
//     }
//   });
// });

$('a[href^=#]').click(function(){
  var speed = 1001;
  var href= $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top;
  $("html, body").animate({scrollTop:position}, speed, "swing");
return false;
});


$(function(){
  // tile exec
  // if (windowWidth > breakPoint) {
  //   $('.nicocas-list li .info').tile(3);
  // } else {
  //   $('.nicocas-list li .info').tile(2);
  // }

	// SP跳ね返り処理時に下が見えてしまう対策
	if (windowWidth > breakPoint) {
		// PCはなにもしない
	} else{
		$(window).scroll(function() {
			var t_position = $('#idx-tsubucon').offset().top;
			var position = $(window).scrollTop();
			if (position > t_position) {
				$('#idx-main').hide();
				$('body').css('background','#000');
			} else{
				$('#idx-main').css('display','block');
				$('body').css('background','none');
			}
		});
	}
});



// WEBPACK FOOTER //
// ./src/assets/js/script.js